export const premintURL = "https://www.premint.xyz/eternal-vikings/";